import React, { useState } from 'react'

import { useHistory } from 'react-router-dom'

import Button from 'components_new/atoms/Button'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'

import MissingDefinitionDialog from 'components_new/organisms/dialogs/MissingDefinitionDialog'

import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useMetric } from 'redux/hooks/Metrics'
import { useTranslation } from 'language/translator'

import { isCustomEconomyMetric } from 'types/GlobalMetric'
import { TCoreWidget } from 'types/GlobalWidget'

interface NoDefinitionProps {
  embedded: boolean
  fetchWidgetData?: (widget: TCoreWidget) => void
  kpiTemplateId: string
  scaleFactor: number
  widget: TCoreWidget
}

/** Shown when a custom economy metric in the widget has no formula yet. */
const NoDefinition = (props: NoDefinitionProps) => {
  const { embedded, fetchWidgetData, kpiTemplateId, scaleFactor, widget } =
    props
  const history = useHistory()
  const { isAdmin, isEconomist } = useAccountSettings()
  const { t } = useTranslation()

  const metric = useMetric(kpiTemplateId, null)

  const [open, setOpen] = useState<boolean>(false)

  const allowConfigure = !embedded && (isAdmin || isEconomist)

  const handleClick = () => {
    if (isCustomEconomyMetric(metric)) {
      setOpen(true)
    } else {
      history.push('/settings/economy')
    }
  }

  return (
    <>
      <EmptyPlaceholder
        actions={
          allowConfigure ? (
            <Button onClick={handleClick}>
              {t('widgets', 'configure_definition')}
            </Button>
          ) : undefined
        }
        background={true}
        title={t('widgets', 'widget_missing_definition_error')}
        icon="Calculation"
        scaleFactor={scaleFactor}
      />
      {open && isCustomEconomyMetric(metric) ? (
        <MissingDefinitionDialog
          metric={metric}
          onClose={() => setOpen(false)}
          onSaved={() => fetchWidgetData?.(widget)}
        />
      ) : null}
    </>
  )
}

export default NoDefinition
